var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgInfo(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 17,
    viewBox: "0 0 16 17",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    fill: "#3057B9"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M8 0c4.418 0 8 3.633 8 8.114 0 4.482-3.582 8.115-8 8.115s-8-3.633-8-8.115C0 3.633 3.582 0 8 0zm0 1.274c-3.725 0-6.744 3.062-6.744 6.84S4.276 14.955 8 14.955c3.725 0 6.744-3.063 6.744-6.84 0-3.779-3.02-6.841-6.744-6.841zm.684 5.16v6.87H7.316v-6.87h1.368zm-.69-3.057c.262-.01.516.091.701.28.36.395.36 1.005 0 1.4-.183.19-.436.29-.697.28-.259.012-.51-.09-.69-.28-.177-.185-.273-.435-.269-.693-.01-.264.088-.52.27-.707.18-.186.428-.288.685-.28z",
    transform: "translate(-189.000000, -480.000000) translate(0.000000, 62.000000) translate(20.000000, 389.000000) translate(169.000000, 29.473103)"
  }))))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInfo);
export default __webpack_public_path__ + "static/media/info.b3a89233b457b50e3961316549a1da8a.svg";
export { ForwardRef as ReactComponent };